import Api from "@/services/Api";

export default {
  fetchWeatherData() {
    return Api().get("getwdata");
  },
  fetchSensorData(params) {
    return Api().get("get-sensor/" + params.sensor);
  },
  fetchSensors() {
    return Api().get("get-sensors");
  }

  //   addPost(params) {
  //     return Api().post("add_post", params);
  //   },

  //   updatePost(params) {
  //     return Api().put("posts/" + params.id, params);
  //   },

  //   getPost(params) {
  //     return Api().get("post/" + params.id);
  //   },

  //   deletePost(id) {
  //     return Api().delete("posts/" + id);
  //   }
};
